export default __webpack_public_path__ + "static/media/back50.101272c0.png";